import Vuex from "vuex"
import { Capacitor } from "@capacitor/core"
import { Device } from "@capacitor/device"
import { checkForExpiredToken } from "../utils/misc.js"
import Home from "./home"
import MyVB from "./myvb"
import News from "./news"
import Navigation from "./navigation"
import Address from "./address"
import Alerts from "./alerts"
import Explore from "./explore"
import Services from "./services"
import Events from "./events"
import Apps from "./apps"
import Notifications from "./notifications"
import Map from "./map"
import Auth from "./auth"
import Settings from "./settings"
import storage from "../utils/storage.js"
import _ from "lodash"

export default new Vuex.Store({
  state: {
    defaultError: "Please reload/refresh, an error was detected. Contact comitmobileteam@vbgov.com if it still occurs.",
    errorMessage: "Please reload/refresh, an error was detected. Contact comitmobileteam@vbgov.com if it still occurs.",
    deviceInfo: undefined,
    storeVersion: "1.0",
  },

  modules: {
    home: Home,
    myvb: MyVB,
    news: News,
    navigation: Navigation,
    address: Address,
    alerts: Alerts,
    explore: Explore,
    events: Events,
    services: Services,
    apps: Apps,
    notifications: Notifications,
    map: Map,
    auth: Auth,
    settings: Settings,
  },

  mutations: {
    /**
     * sets the device info
     * @param {*} state
     * @param {*} deviceInfo
     */
    async setDeviceInfo(state, deviceInfo) {
      state.deviceInfo = await Device.getInfo()
    },
    /**
     * sets the error message
     * @param {*} state
     * @param {*} message
     */
    setErrorMessage(state, message) {
      state.errorMessage = message
    },

    /**
     * restores the store
     * @param {*} state
     * @param {*} storedData
     */
    restoreStore(state, storedData) {
      if (storedData) {
        _.merge(state, storedData) // Deep merge existing state with stored state
      }
    },
  },
  actions: {
    /**
     * initialises the store
     * @param {*} param0
     */
    async initialiseStore({ commit }) {
      try {
        let storedData = await storage.getItem("store")
        if (storedData) {
          storedData = JSON.parse(storedData) // Parse JSON safely
          commit("restoreStore", storedData) // Commit to mutation
        }
      } catch (error) {
        console.error("Error loading persisted store:", error)
      }
    },

    /**
     * sets the error message
     * @param {*} param0
     * @param {*} message - if undefined/null use default
     */
    setErrorMessage({ commit, state }, message) {
      let error = message

      if (message === undefined || message === null) {
        error = state.defaultError
      }

      commit("setErrorMessage", error)
    },
  },
})
